// 프로필 이미지 변경
jQuery( '.profilePhoto .btn_changePhoto, .thumb .btn_changePhoto, .wrap_intro .btn_changePhoto' ).click(function() {

	if( !NP.dt.v ){
		alert( '로그인 해주시기 바랍니다.');
		return;
	};

	if ( !profileImgUploadG ) {
		profileImgUploadG = new nc.playinG.ImageUpload( document.body, {
			channel: 'ProfileImage',
			tokenUrl: ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/' + ( !NP.isIntro ? NP.dt.st + '/photo' : 'bns/intro' ) + '/createToken.json',
			fileInfo: ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/' + ( !NP.isIntro ? NP.dt.st + '/photo' : '/bns/intro' ) + '/tokenfileinfo.json',
			removeFileInfo: ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/' + ( !NP.isIntro ? NP.dt.st + '/photo' : '/bns/intro' ) + '/deleteFile.json',
			iframe: '/resources/jsp/editor/btnFileUpload.html',
			editFrame: '/resources/jsp/editor/FileModify.html',
			filterImageUrl: '/resources/jsp/editor/symbol/',
			//thumbnailUrl: NP.FILESVR_URL + 'download_thumblarge/',
			//thumbnailUrl: NP.FILESVR_URL + 'download/',
			thumbnailUrl: NP.FILESVR_PROFILE_URL + 'download',
			maxImages: 1,
			objectName : 'profileImgUploadG',
			isUrlUpload: false,
			isProfileUpload: true,
			localFileEnable : true,
			onComplete : function() {
				var images = profileImgUploadG.getImages()[ 0 ],
					data = {
						imgIds : [''],
						imgUrl : images.fileUrl,
						channel: 'ProfileImage',
						fileId: images.id,
						token : profileImgUploadG.getToken(),
						isProfileAlbum : !0
					};

				if ( NP.isIntro ) {
					jQuery( '#profilePhoto' ).attr( 'src', images.fileUrl );
					jQuery( '#profilePhoto' ).attr( 'data-file-id', images.id );
				} else {
					jQuery.ajax({
						type : 'post',
						url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.o + '/SNS/photo',
						dataType : 'json',
						data : data,
						/*data : {
							imgIds : !NP.isIntro ? '' : images.id ? [ images.id ] : [ images.fileUrl ], // intro 에서는 안넘기자
							//imgUrl : images.id ? '' : images.fileUrl,
							imgUrl : images.fileUrl,
							token : profileImgUploadG.getToken(),
							isProfileAlbum : !0
						},*/
						success : function( data ) {
							window.location.reload();
						}
					});
				}
			}
		});
	} else {
		profileImgUploadG.init();
		profileImgUploadG.showNewToken();
	}
	return false;
});

// SelectBox
function selectbox( pane ){
	jQuery((pane?pane:"") + ' .js_select').not('.done').each(function(){
		jQuery(this).addClass('done');
		var options = {
			jsSelect	:	jQuery(this),
			jsSelected	:	jQuery(this).find('.js_selected:not(.notSelected)',0),
			jsSelector	:	jQuery(this).find('.js_selector',0),
			chkInput	:	jQuery(this).find(':radio:checked'),
			chkLabel	:	jQuery(this).find(':radio:checked').parent()
		};

		//box viewer
		options.jsSelected.bind('click', function(){
			layerManaged.toggle(jQuery(this), options.jsSelector);
			NP.zIndex['+'](options.jsSelect);
		});

		//onchange && click
		options.jsSelector.find(':radio').bind('click', function(e){
			options.chkInput = jQuery(e.target);
			options.chkLabel = jQuery(e.target).parent();
			doSelect();
		});

		//선택했을때
		var doSelect = function(){
			options.jsSelect.find('label').removeClass('checked');
			//label에 text가 있으면 jsSelected에 넣어줌
			if(options.chkInput.html()!=null){
				options.chkLabel.addClass('checked');
				options.jsSelected.html( options.chkLabel.html() ).find('input').remove();
			}
			options.jsSelector.hide();
		}

		//checked된 input이 없을 경우 첫번째 input에 checked
		if(!options.chkInput.is(':checked')){
			options.chkInput = options.jsSelector.find(':radio').eq(0);
			options.chkLabel = options.chkInput.parent();
		}
		doSelect();
	});
}
selectbox();

function selectedBox( pane, charId, serverId, isOne, isGroup ){

	var idx = 0;
	jQuery((pane? pane: '' ) + ' .js_select').each(function(){
		if( !jQuery(this).hasClass( 'selectSetChar' ) || isOne ){
			var options = {
				jsSelect	:	jQuery(this),
				jsSelected	:	jQuery(this).find('.js_selected',0),
				jsSelector	:	jQuery(this).find('.js_selector',0),
				chkInput	:	jQuery(this).find(':radio:checked'),
				chkLabel	:	jQuery(this).find(':radio:checked').parent()
			};

			if( !isGroup ){
				options.chkInput = jQuery( 'input[data-chrtid=' + charId + '][data-svrid=' + serverId + ']' );
				//options.chkInput = options.jsSelect.find( 'input[data-chrtid=' + charId + '][data-svrid=' + serverId + ']' );
			}else{
				options.chkInput = options.jsSelect.find( 'input[value!=0]' ).eq(0);
			}

			if( options.chkInput ){

				jQuery(this).find( ':radio:checked' ).prop( 'checked', false );

				options.chkInput.prop( 'checked', true );
				options.chkLabel = options.chkInput.parent();

				options.chkLabel.addClass('checked');
				options.jsSelected.html( options.chkLabel.html() ).find('input').remove();

				if( !options.chkInput.is(':checked') ){
					options.chkInput = options.jsSelector.find(':radio').eq(0);
					options.chkLabel = options.chkInput.parent();
				}
			}
		}
	});

	var selectSetChar = jQuery( '#writeShort .selectSetChar' ),
		chkInput = selectSetChar.find( 'input[value!=0]' ),
		chkLabel, selectedTxt = selectSetChar.find( '.js_selected' );

	if( chkInput.length == 1 ){
		chkLabel = chkInput.parent();
		selectSetChar.find( ':radio:checked' ).prop( 'checked', false );
		chkInput.prop( 'checked', true );
		chkLabel.addClass( 'checked' );
		selectedTxt.html( chkLabel.html() ).find( 'input' ).remove();
	}
};

function changeConnectButton( me, state ) {
	jQuery( me ).removeClass( 'ing cancel complete confirm gray1 gray2 gray3 bluish1 bluish2 bluish3' );
	if ( state === '친구신청' ) {
		jQuery( me ).addClass( 'bluish1' ).attr( 'data-current', '0' );
	} else if ( state === '친구신청중' ) {
		jQuery( me ).addClass( 'gray2' ).attr( 'data-current', '1' );
	} else if ( state === '신청취소' ) {
		jQuery( me ).addClass( 'bluish3' );
	} else if ( state === '친구신청수락' ) {
		jQuery( me ).addClass( 'bluish3' );
	} else if ( state === '친구' ) {
		jQuery( me ).addClass( 'bluish2' ).attr( 'data-current', '2' );
	} else if ( state === '구독' ) {
		jQuery( me ).attr( 'data-current', '0' );
	} else if ( state === '구독취소' ) {
		jQuery( me ).addClass( 'cancel' );
	} else if ( state === '구독중' ) {
		jQuery( me ).addClass( 'complete' ).attr( 'data-current', '1' );
	}
	jQuery( me ).text( state );
}
NP.body.on( 'mouseover', '.js_btnFollow', function() {
	if ( jQuery( this ).attr( 'data-current' ) === '1' ) {
		changeConnectButton( this, '구독취소' );
	}
}).on( 'mouseout', '.js_btnFollow', function() {
	if ( jQuery( this ).attr( 'data-current' ) === '1' && !jQuery( this ).hasClass( 'unfollow' ) ) {
		changeConnectButton( this, '구독중' );
	}
}).on( 'mouseover', '.js_btnFriend', function() {
	if ( jQuery( this ).attr( 'data-current' ) === '1' ) {
		changeConnectButton( this, '신청취소' );
	}
}).on( 'mouseout', '.js_btnFriend', function() {
	if( jQuery( this ).attr( 'data-current' ) === '1' ) {
		changeConnectButton( this, '친구신청중' );
	}
});
/* function changeConnectButton( me, state ) {
	$( me ).removeClass( 'ing cancel complete confirm gray1 gray2 gray3 bluish1 bluish2 bluish3' );
	if ( state === '친구신청' ) {
		$( me ).addClass( 'bluish1' ).attr( 'data-current', '0' );
	} else if ( state === '친구신청중' ) {
		$( me ).addClass( 'gray2' ).attr( 'data-current', '1' );
	} else if ( state === '친구신청취소' ) {
		$( me ).addClass( 'bluish3' );
	} else if ( state === '친구신청수락' ) {
		$( me ).addClass( 'bluish3' );
	} else if ( state === '친구' ) {
		$( me ).addClass( 'bluish2' ).attr( 'data-current', '2' );
	} else if ( state === '팔로우' ) {
		$( me ).attr( 'data-current', '0' );
	} else if ( state === '팔로우 취소' ) {
		$( me ).addClass( 'cancel' );
	} else if ( state === '팔로잉' ) {
		$( me ).addClass( 'complete' ).attr( 'data-current', '1' );
	}
	$( me ).text( state );
}
NP.body.on( 'mouseover', '.js_btnFollow', function() {
	if ( $( this ).attr( 'data-current' ) === '1' ) {
		changeConnectButton( this, '팔로우 취소' );
	}
}).on( 'mouseout', '.js_btnFollow', function() {
	if ( $( this ).attr( 'data-current' ) === '1' && !$( this ).hasClass( 'unfollow' ) ) {
		changeConnectButton( this, '팔로잉' );
	}
}).on( 'mouseover', '.js_btnFriend', function() {
	if ( $( this ).attr( 'data-current' ) === '1' ) {
		changeConnectButton( this, '친구신청취소' );
	}
}).on( 'mouseout', '.js_btnFriend', function() {
	if( $( this ).attr( 'data-current' ) === '1' ) {
		changeConnectButton( this, '친구신청중' );
	}
}); */


//Left 친구/구독중/구독
var myConnectList = (function($){
	var _h2 = $('#myConnectList h2');
	var _ul = $('#myConnectList ul');

	_h2.find('a').mouseenter(function(){
		_show( this );
	});
	$('#myConnectList').mouseleave(function(){
		_show( _h2.find('a.on')[0] );
	});

	function _show( showing ){
		if( !showing ) showing = _h2.find('a')[0];

		if( !$(showing).hasClass('hover') ){
			_h2.find('a').removeClass('hover');
			_ul.hide();

			$(showing).addClass('hover');
			$(showing).parent().next().show();
		}
	}

	_show( _h2.find('a.on')[0] );
}(jQuery));


// 랜덤 프로필
jQuery(function() {
	var photo = jQuery( '#profilePhoto' ),
		backup = photo.attr( 'src' );

	jQuery( 'button.setting' ).click(function() {
		var v = randomProfileData[ NP.random.get( randomProfileData.length ) ];
		photo.attr({ src : NP.RESOURCE_URL + v.url, alt : v.alt });
		$( '#prflIntroTxt' ).val('').attr( 'placeholder', v.intro );
		NP.Placeholder.set( $('#inputProfile') );
	});
	jQuery( '.chooseThumb button.reload' ).click(function() {
		var v = randomProfileData[ NP.random.get( randomProfileData.length ) ];
		photo.attr({ src : NP.RESOURCE_URL + v.url, alt : v.alt });
	});

	jQuery( '.chooseThumb button.back' ).click(function() {
		photo.attr({ src : backup, alt : '' });
	});
	jQuery( '#inputProfile dd .random' ).click(function() {
		jQuery( '#prflIntroTxt' ).val('').attr( 'placeholder', randomProfileData[ NP.random.get( randomProfileData.length ) ].intro );
		NP.Placeholder.set( jQuery('#inputProfile') );
	});
});



var layerManaged = (function($){
	var _ShowLayers = '';

	$(document).click(function(e){
		if( $(e.target).is(_ShowLayers[0]) ) return;
		if( $(_ShowLayers[0]).has($(e.target)).length ) return;
		if( $(_ShowLayers[1]).has($(e.target)).length ) return;
		layerManaged.hide();
	});

	return {
		toggle : function(button, layer){
			if( layer.css('display')!='none' && button.is(_ShowLayers[0]) ) layerManaged.hide();
			else layerManaged.show(button, layer);
		},
		show : function(button, layer){
			if( !button.is(_ShowLayers[0]) ) layerManaged.hide();
			_ShowLayers = [button, layer];
			NP.zIndex['+'](layer);
			button.addClass('on');
			layer.show();
		},
		hide : function() {
			if(_ShowLayers){
				NP.zIndex['-'](_ShowLayers[1]);
				NP.zIndex['-'](_ShowLayers[1].parent()); //IE7처리
				_ShowLayers[0].removeClass('on');
				_ShowLayers[1].hide();
				_ShowLayers = '';
			}
		}
	};
}(jQuery));

var layerManagedV2 = (function($){
	var _ShowLayers = '';

	$(document).click(function(e){
		if( $(e.target).is(_ShowLayers[0]) ) return;
		if( $(_ShowLayers[0]).has($(e.target)).length ) return;
		if( $(_ShowLayers[1]).has($(e.target)).length ) return;
		layerManagedV2.hide();
	});

	return {
		toggle : function(button, layer, fn){
			if( layer.css('display')!='none' && button.is(_ShowLayers[0]) ) layerManagedV2.hide();
			else layerManagedV2.show(button, layer, fn);
		},
		show : function(button, layer, fn){
			if( !button.is(_ShowLayers[0]) ) layerManagedV2.hide();
			_ShowLayers = [button, layer, fn];

			if( layer.parent() != $('body') ){
				layer.css('display', 'block');
				var width = layer.width();
				var o = layer.offset();
				layer.css({
					'position' : 'absolute',
					'left' : o.left,
					'top' : o.top,
					'width' : width
				}).appendTo( $('body') );
			}
			NP.zIndex['+'](layer);
			//layer.slideDown();
			button.addClass('on');
			layer.show();

			if ( fn ) {
				fn(button, layer);
			}
		},
		hide : function() {
			if(_ShowLayers){
				NP.zIndex['-'](_ShowLayers[1]);
				_ShowLayers[0].removeClass('on');
				_ShowLayers[1].hide();
				//_ShowLayers[1].slideUp();

				if ( _ShowLayers[2] ) {
					_ShowLayers[2](_ShowLayers[0], _ShowLayers[1]);
				}

				_ShowLayers = '';
			}
		}
	};
}(jQuery));

//추천 친구 관계 더보기
jQuery('#container').on('click', '.js_moreConnect', function() {
	if( !jQuery(this).data('ctrled') ) {
		jQuery(this).data('ctrled', jQuery(this).next() );
	}

	layerManagedV2.toggle( jQuery(this) , jQuery(this).data('ctrled') );
});

var tagInputCtrl = (function($) {
	function tagInputCtrl(options){
		this.options = options;
		this.hiddenWrapperData = [];//현재 hidden값
		this.load();
		this.evtBind();
	}


	tagInputCtrl.prototype.load = function() {
		var i=0;

		while(this.hidden(i).length){
			this.hiddenWrapperData[i] = this.hidden(i);
			i++;
		};
		this.output();
	};
	//현재 hidden값을 배열로 돌려줌
	tagInputCtrl.prototype.hidden = function(index) {
		for(var j=0, c=[], l=this.options.hiddenInput.length; j<l ; j++){
			var b = this.options.hiddenWrapper.find( '[name="' + this.options.hiddenInput[j].replace('{index}', index) + '"]' ).val();
			if(b) c.push( b );
		}
		return c;
	};
	tagInputCtrl.prototype.output = function() {
		var viewWrapperDom = this.options.viewWrapper.find('.data');
		var viewWrapperDomHtml = '';
		var hiddenWrapperHtml = '';
		viewWrapperDom.html('');
		this.options.hiddenWrapper.html('');
		for (var j=0, item; item=this.hiddenWrapperData[j] ; j++){
			if(j) viewWrapperDomHtml += ', ';
			viewWrapperDomHtml += item[1]+' <a class="delete">삭제</a>';

			for(var i=0, l=this.options.hiddenInput.length; i<l ; i++){
				hiddenWrapperHtml += '<input type="hidden" name="'+this.options.hiddenInput[i].replace('{index}', j)+'" value="'+item[i]+'"/>';
			}
		}
		viewWrapperDom.append( viewWrapperDomHtml );
		this.options.hiddenWrapper.append( hiddenWrapperHtml );
	};
	tagInputCtrl.prototype.add = function(seq, keyword, input) {
		if(!seq) seq = 0;

		var v = $.trim(input.val());
		//빈값chk
		if(!v.length) {
			input.blur();
			modal.show({
				txt : '값을 입력해 주세요.',
				button : [[ 'confirm', function() {
					this.hide();
					input.focus();
				}]]
			});
			input.val('');
			return;
		}

		//중복chk
		for(var i=0 ; i<this.hiddenWrapperData.length ; i++){
			// val이 중복되고 중복된 값이면
			if(this.hiddenWrapperData[i][1]==input.val()){
				input.blur();
				modal.show({
					txt : '이미 입력되어 있습니다.',
					button : [[ 'confirm', function() {
						this.hide();
						input.focus();
					}]]
				});
				return;
			}
		}
		input.focus();

		this.hiddenWrapperData.push([seq, keyword]);
		this.output();
		input.val( '' );
	};
	tagInputCtrl.prototype.remove = function(index) {
		this.hiddenWrapperData.splice(index, 1);
		this.output();
	};

	//데이터 영역 Binding
	tagInputCtrl.prototype.evtBind = function() {
		var me = this;

		this.options.viewWrapper.on('click', '.delete', function() {
			me.remove($(this).index());
		});
		this.options.viewWrapper.bind({
			keyup:function(e){
				var limit_char = '/[~!\#$%^&*;//\=+|:;?"<,.>\']/';
				var x = limit_char.indexOf( $(e.target).val().substr($(e.target).val().length-1, 1) );

				if(x && -1<x){
					$(e.target).blur();
					modal.show({
						txt : '특수문자는 입력 할 수 없습니다.',
						button : [[ 'confirm', function() {
							this.hide();
							$(e.target).focus();
						}]]
					});
					$(e.target).val( $(e.target).val().substr(0, $(e.target).val().length-1) );
				}
			}
		});
	};

	return tagInputCtrl;
}( jQuery ));

//자동완성 - 닉네임
// if( window.ncSuggestV2 ){
// var nicknameSuggest = new ncSuggest({
// 	trigger : 'nickname',
// 	//url : 'http://funweb04:12001/openapi/npusersuggest.jsp',
// 	url : 'http://search.plaync.co.kr/openapi/npusersuggest.jsp', // Suggest URL
// 	suggestType : 'front', // 전방/중간/후방 Defualt : 'front|mid|back'
// 	list : function( suggestion, data ) { // 자동완성 결과리스트
// 		//return '<img src="http://static.plaync.co.kr/sandbox/@tmp/user1.gif" alt="'+suggestion+'">' +( suggestion ? data[ 0 ].replace( suggestion, '<em>' + suggestion + '</em>' ) : data[ 0 ] ) + '<input type="hidden" name="guid" value="' + data[ 2 ] + '" />';
// 		return '<img src="' + NP.sfile( data[ 1 ] ) + '" alt="'+suggestion+'">' +( suggestion ? data[ 0 ].replace( suggestion, '<em>' + suggestion + '</em>' ) : data[ 0 ] );
// 	},
// 	param : { // Parameter
// 		site : 'sandbox' // siteFlag
// 		//display : 10, // 검색 결과 수( 전방/중간/후방 각각 ) Default : 10
// 	}
// });
// }

function guideBalloon( no ) {
	if( getCookie('sandboxGuide')=='0' || NP.dt.st=='my' || NP.dt.loc!='wall' ) {
		return;
	}

	var balloon, o;
	no = ( !no && getCookie('sandboxGuide') ) ? getCookie('sandboxGuide') : '1';
	show( no );

	function show( no ) {
		if( !no ) return;
		if( no=='1' && jQuery('.wrap_whoami .edit').length ) {
			balloon = jQuery('<div class="guideBalloon"><img src="'+NP.STATIC_URL+'/sandbox/bns/guideballoon/edit.gif" alt="" /><a>다음</a></div>').css({
				'position' : 'absolute',
				'top' : '15px',
				'left' : '-8px'
			}).appendTo( jQuery('.wrap_whoami .edit').eq(0) );
		} else if ( no=='2' && jQuery('.menu_navigation').length ) {
			balloon = jQuery('<div class="guideBalloon"><img src="'+NP.STATIC_URL+'/sandbox/bns/guideballoon/story.gif" alt="" /><a>다음</a></div>').css({
				'position' : 'absolute',
				'top' : '51px',
				'left' : '20px'
			}).appendTo( jQuery('.menu_navigation').eq(0) );
		} else if ( no=='3' && jQuery('.wrap_editorShort .textarea').length ) {
			balloon = jQuery('<div class="guideBalloon"><img src="'+NP.STATIC_URL+'/sandbox/bns/guideballoon/uploadImage.gif" alt="" /><a>다음</a></div>').css({
				'position' : 'absolute',
				'top' : '35px',
				'left' : '522px'
			}).appendTo( jQuery('.wrap_editorShort .textarea').eq(0) );

			jQuery('.wrap_editorShort .textarea').eq(0).click(function(e){
				hide();
			});
		} else if ( no=='4' && jQuery('.wrap_doYouKnow > ul > li').length ) {
			balloon = jQuery('<div class="guideBalloon"><img src="'+NP.STATIC_URL+'/sandbox/bns/guideballoon/recommendFriend.gif" alt="" /><a>다음</a></div>').css({
				'position' : 'absolute',
				'top' : '47px',
				'left' : '2px'
			}).appendTo( jQuery('.wrap_doYouKnow > ul > li:last') );
		} else {
			setCookie( 'sandboxGuide', '0', 1000);
			return;
		}
		setCookie( 'sandboxGuide', no, 1000);

		o = balloon.offset();
		NP.zIndex['+'](balloon);

		balloon.css({
			'position' : 'absolute',
			'left' : o.left,
			'top' : o.top + 15,
			'opacity' : '0.25'
		}).prependTo( jQuery('body') ).animate({
			'top' : o.top,
			'opacity' : 1
		}, 400);


		balloon.find('a').click(function() {
			hide();
			setTimeout(function() {
				show( Number(no)+1 );
			}, 650);
		});
	}

	function hide() {
		balloon.animate({
			'top' : o.top + 20,
			'opacity' : 0
		}, 600, function() {
			balloon.remove();
		});
	}

	function getCookie( name ){
		var nameOfCookie = name + "=";
		var endOfCookie, y, x = 0;
		while ( x <= document.cookie.length ) {
			y = (x+nameOfCookie.length);
			if ( document.cookie.substring( x, y ) == nameOfCookie ) {
				if ( (endOfCookie=document.cookie.indexOf( ";", y )) == -1 )
					endOfCookie = document.cookie.length;
					return unescape( document.cookie.substring( y, endOfCookie ) );
			}
			x = document.cookie.indexOf( " ", x ) + 1;
			if ( x == 0 )
				break;
		}
		return "";
	}

	function setCookie( name, value, expiredays ){
		var todayDate = new Date();
		todayDate.setDate( todayDate.getDate() + expiredays );
		document.cookie = name + "=" + escape( value ) + "; path=/; expires=" + todayDate.toGMTString() + ";"
	 }
}

// After DOM Loaded
jQuery(function() {
	NP.isIntro = NP.dt.page === '' && NP.dt.loc === '' && location.href.indexOf( '/intro' ) > 0 ? !0 : !1;
	NP.onDomLoad.fire();
	NP.WriteForm && NP.WriteForm.textarea.length && guideBalloon();
});

// Position Fixed
(function() {
	var aside = jQuery( '.wrap_right' );

	if ( aside.length ) {
		var offset = $('#contents').offset(),
			top = offset.top;

		jQuery( window ).scroll(function() {
			if( top < jQuery( this ).scrollTop() ) {
				aside.addClass('js_posFixed');
			} else {
				aside.removeClass('js_posFixed');
			}
			/*
			if( top < jQuery( this ).scrollTop() ) {
				aside.css({
					'position' : 'fixed',
					'top' : '0',
					'left' : '50%',
					'marginLeft' : '330px'
				});
			} else {
				aside.css({
					'position' : 'static',
					'marginLeft' : ''
				});
			}
			*/
		});
	}

	var sTop = jQuery( '.scrollTop' );

	if ( sTop.length ) {

		function scrollTop(){
			if( jQuery(window).scrollTop() > jQuery('body').outerHeight() - jQuery(window).height() - jQuery('#footer, .footerWrap, footer.footer').outerHeight() ){
				jQuery('.scrollTop').addClass('sTopAbsolute' );
			} else {
				jQuery('.scrollTop').removeClass('sTopAbsolute');
			}
		}
		scrollTop();

		jQuery( window ).scroll(function() {
			scrollTop();
		});
	}

}());
NP.contents.find( '.list_friends' ).on( 'mouseleave', 'li', function() {
	jQuery(this).find('.context').hide();
});